module.exports = __webpack_public_path__ + "img/Twitter_Logo_WhiteOnImage.d73d21cf.png";